import {cpfCnpj, phone} from '../../../../../filters/string'

export default {
  props: ['contact'],
  data() {
    return {
    }
  },
  created: function() {
    this.$watch('contact', () => {
      let vm = this;
      setTimeout(function(){
        vm.$validator.validateAll()
        .then(() => {
          vm.contact.validForm = true;
        })
        .catch(err => {
          vm.contact.validForm = false;
        })
      }, 300);
    }, { deep: true });
  },
  mounted() {
    
  },
  computed: {
    tel: {
      get() {
        return this.getTelFormated();
      },
      set(newValue) {
        this.setTelFormated(newValue);
      }
    },
    cel: {
      get() {
        return this.getCelFormated();
      },
      set(newValue) {
        this.setCelFormated(newValue);
      }
    }
  },
  methods: {
    correctCursor2(a){
      if(!window.document.mobile)
        return;

      setTimeout(() => {
        $(a.target).val($(a.target).val());
      }, 80);
    },
    getTelType(type) {
      let tels = _.filter(this.contact.telephones.telephone, o => o.type == type)
      if (tels && tels.length > 0)
        return tels[0];

      var t = { 'ddd': '', 'numberPhone': '', 'type': type }
      this.contact.telephones.telephone.push(t);

      return t;
    },
    getCelFormated(obj) {
      return phone(this.contact.dddCellphone + this.contact.nroCellphone);
    },
    setCelFormated(value) {
      let t = value.replace(/[^0-9]/g, '');
      
      this.contact.dddCellphone = t.substring(0, 2);
      this.contact.nroCellphone = t.substring(2, 11);

    },
    getTelFormated(obj) {
      return phone(this.contact.dddPhone + this.contact.nroPhone);
    },
    setTelFormated(value, obj) {
      let t = value.replace(/[^0-9]/g, '');
      this.contact.dddPhone = t.substring(0, 2);
      this.contact.nroPhone = t.substring(2, 11);
    },
    validateAll(){
      let vm = this;
      return this.$validator.validateAll()
        .then( r => {
          vm.contact.email = vm.contact.email;
          vm.contact.celPhone = vm.contact.cel;
          // vm.$emit('contactData', vm.contact);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/aggregate-register/contact.js